// OtpInput.js

import React, { useState, useRef } from 'react';
import { OtpInputWrapper } from './Otp.styles';
import { useEffect } from 'react';
import iconClock from '../../../assets/icon-clock.svg';
const OtpInput = ({ numInputs = 5, inputWidth, width, inputBg, noTimer, handleResentOtp, setOtpValue = () => {} }) => {
  const initailTime = 300;
  const [timeLeft, setTimeLeft] = useState(initailTime);
  const [otp, setOtp] = useState(new Array(numInputs).fill(''));
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef()];
  const [runagain, setRunagain] = useState(false);
  const restartTimer = async () => {
    await handleResentOtp();
    setRunagain(true);
    setTimeLeft(initailTime);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    // Cleanup timer on component unmount
    return () => clearInterval(timer);
  }, [runagain]);

  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  const handleChange = (index, value) => {
    if (otp[index] !== '' && index + 1 === numInputs) {
      return;
    }

    if (otp[index] !== '') {
      if (refs[index + 1]?.current) {
        refs[index + 1].current.focus();
      }

      const newOtp = [...otp];
      newOtp[index + 1] = value.split('')[1];

      setOtp(newOtp);
      setOtpValue(newOtp);
      return;
    }

    if (parseInt(value) <= 9) {
      const newOtp = [...otp];
      newOtp[index] = value;

      setOtp(newOtp);
      setOtpValue(newOtp);
    }

    if (refs[index + 1]?.current) {
      refs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      e.preventDefault(); // Prevent the default behavior to avoid unintended navigation

      // Clear the current input
      setOtp(prev => {
        const newOtp = [...prev];
        newOtp[index] = ''; // Clear the current index

        return newOtp;
      });

      // Move focus to the previous input if available
      if (refs[index - 1]?.current) {
        refs[index - 1].current.focus();
      }
    }
  };

  return (
    <OtpInputWrapper $width={width} $inputWidth={inputWidth} $inputBg={inputBg}>
      <div className="otp-fields">
        {otp.map((value, index) => (
          <input
            placeholder="-"
            key={index}
            type="number"
            maxLength={1}
            value={value}
            onChange={e => handleChange(index, e.target.value)}
            onKeyDown={e => handleKeyDown(index, e)}
            ref={refs[index]}
          />
        ))}
      </div>
      {noTimer ? (
        ''
      ) : (
        <div className="timer">
          {timeLeft === 0 && (
            <span className="resend-code" onClick={restartTimer}>
              Resend code{' '}
            </span>
          )}
          {timeLeft !== 0 && (
            <span
              style={{
                width: '100%',
                color: '#313131',
                justifyContent: 'end',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
              }}>
              <img src={iconClock} width="20  " alt="clock" /> {formatTime(timeLeft)}{' '}
            </span>
          )}
        </div>
      )}
    </OtpInputWrapper>
  );
};

export default OtpInput;
